module.exports = __webpack_public_path__ + "VIPH3.png?0cb9d299b8b535e3d4dc142c35a2b6a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH3.png
// module id = 96
// module chunks = 0